import {
  FileDto,
  LabelFieldType,
  LabelFieldOptionType,
  LabelType,
} from 'app/types';
import { ToastService } from 'app/services/toast/toast.service';

export function redirectTo(link: string): void {
  window.open(link, '_blank');
}

// clipboard.utils.ts
export function copyToClipboard(
  text: string,
  toastService: ToastService,
): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);

  if (toastService) {
    toastService.success({
      detail: 'Password copied to clipboard!',
    });
  }
}

function _isFieldOptionSet(
  file: FileDto | undefined,
  fieldType: LabelFieldType,
  optionType?: LabelFieldOptionType,
): boolean | undefined {
  return file?.labels?.some(
    (fl) =>
      fl.label.type === LabelType.OVERLAYER &&
      fl.label_field.type === fieldType &&
      (!optionType || fl.selected_options.some((o) => o.type === optionType)),
  );
}

export function isFileFlagged(
  file: FileDto | undefined,
): boolean {
  return !!_isFieldOptionSet(
    file,
    LabelFieldType.NEEDS_UPDATE,
    LabelFieldOptionType.NEEDS_UPDATE_FLAGGED,
  );
}

export function isError(error: number, targetError: number) {
  return Math.trunc(error / 100) * 100 === targetError;
}
